module.exports = __webpack_public_path__ + "static/media/sass.3e3a8cda.svg";